import { Col, Row, Button, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';


const Tablecolumns = (loading, editarIdioma, deleteIdIdiomaMe) =>
    [
        {
            title: 'Idioma / lengua indígena',
            dataIndex: 'idioma',
            key: 'idioma',
            width: "30%",
        },
        {
            title: 'Nivel',
            key: 'nivel',
            width: "15%",
            render: (_, { tipo_idioma, nivel_dominio, nivel_mcer }) => {
                return tipo_idioma === 'Idioma Extranjero' ? `${nivel_mcer}` : `${nivel_dominio}`;
            },
        },
        {
            title: 'Certificación',
            dataIndex: 'certificacion',
            key: 'certificacion',
            width: "20%",
            render: (_, { certificacion, nombre_certificacion }) => {
                return certificacion ? `Certificación en: ${nombre_certificacion}` : 'No';
            },
        },
        {
            title: 'Acciones',
            dataIndex: 'acciones',
            key: 'acciones',
            width: "20%",
            align: 'center',
            render(_, record) {
                return (
                    <>
                        <Row gutter={[8, 8]} justify="center">
                            <Col>
                                <Tooltip title="Editar idioma">
                                    <Button
                                        loading={loading}
                                        size="small"
                                        onClick={() => editarIdioma(record)}
                                        icon={<EditOutlined />}
                                        shape='circle'
                                    />
                                </Tooltip>
                            </Col>
                            <Col>
                                <Tooltip title="Eliminar idioma">
                                    <Popconfirm
                                        title="¿Deseas eliminar esta idioma?"
                                        onConfirm={() => deleteIdIdiomaMe(record.id_idioma)}
                                    >
                                        <Button
                                            loading={loading}
                                            danger
                                            size="small"
                                            icon={<DeleteOutlined />}
                                            shape='circle'
                                        />
                                    </Popconfirm>
                                </Tooltip>
                            </Col>
                        </Row>
                    </>
                )
            }
        },
    ]

export default Tablecolumns;